import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { Dropdown } from "../../../dropdown";
import { primeIcon } from "../../../icon";
import styles from "../../filter-panel.module.scss";
import type { FilterPanelSavedListViewProps } from "./types-saved-list";

const TRASH_ICON = primeIcon("trash", 14);

export function FilterPanelSavedListView({
  className,
  active,
  rest,
  dropdownRef,
  onShow,
  onHide,
  value,
  options,
  onChange,
  placeholder,
  emptyMessage,
  empty,
  testId,
  deleteTestId,
  delete: remove,
}: FilterPanelSavedListViewProps) {
  return (
    <div className={classNames(styles.savedList, className)} data-active={active} {...rest}>
      <Dropdown
        ref={dropdownRef}
        size="sm"
        className={styles.savedField}
        panelClassName={classNames(styles.savedPanel, empty && styles.savedPanelEmpty)}
        onShow={onShow}
        onHide={onHide}
        value={value}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        emptyMessage={emptyMessage}
        aria-label={placeholder}
        data-testid={testId}
      />
      {remove ? (
        <Button
          type="button"
          icon={TRASH_ICON}
          text
          severity="secondary"
          aria-label={remove.label}
          onClick={remove.onClick}
          data-testid={deleteTestId}
        />
      ) : null}
    </div>
  );
}
